<template>
  <div class="main-box detail-view" v-if="!person">
    <b-alert variant="warning" show class="my-0" >
      Sie haben keinen Zugriff
    </b-alert>
  </div>
  <b-overlay :show="showOverlay" rounded="sm" v-else>
    <div class="main-box detail-view">
      <h1>Personendetail</h1>
      <div class="my-2">
        <b-button to="/person">Zurück</b-button>
      </div>
      <b-table class="detail-view" :fields="fields" :items="[person]" stacked>
        <template v-slot:empty>
          <h4>Keine Einträge</h4>
        </template>
        <template v-slot:cell(strasse)="row">
          <span>{{ row.item.strasse }} {{ row.item.hausNr }}</span>
        </template>
        <template v-slot:cell(plz)="row">
          <span>{{ row.item.plz }} {{ row.item.ort }}</span>
        </template>
        <template v-slot:cell(oeffentlicheHand)="row">
          <span>{{ row.item.oeffentlicheHand ? 'Ja' : 'Nein' }}</span>
        </template>
      </b-table>
      <div class="my-2">
        <b-button :to="`/person/${this.$route.params.personId}/bearbeiten`" variant="primary">
          Bearbeiten
        </b-button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      fields: [
        { key: 'anrede' },
        { key: 'vorname' },
        { key: 'name' },
        { key: 'firma' },
        { key: 'zusatz' },
        { key: 'uid', label: 'UID' },
        { key: 'oeffentlicheHand', label: 'öffentliche Hand' },
        { key: 'strasse', label: 'Strasse/Nr' },
        { key: 'plz', label: 'PLZ/Ort' },
        { key: 'telefon' },
        { key: 'email', label: 'E-Mail' },
        { key: 'landBezeichnung', label: 'Land' }
      ],
      showOverlay: true,
      hasNoAccess: false
    }),
    created () {
      const { personId } = this.$route.params
      this.getPerson(personId)
    },
    methods: {
      getPerson (personId) {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('person/GET_PERSON_BY_ID', { personId, includeOrganisation: false }).then(res => {
          const { errors } = res

          if (errors) {
            this.showOverlay = false
            return errorHandler(this, errors)
          }
          this.showOverlay = false
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    computed: {
      ...mapGetters({ person: 'person/PERSON' })
    }
  }
</script>

<style lang="scss">
  .detail-view .table.b-table.b-table-stacked > tbody > tr > [data-label]::before{
     text-align: left !important;
   }
</style>
